import React from "react";
import { Link, useLocation } from "react-router-dom";
import * as Icons from "lucide-react";

const BottomNav = () => {
  const location = useLocation();

  const navItems = [
    { name: "Dashboard", icon: Icons.LayoutDashboard, route: "/user/dashboard" },
    { name: "Orders", icon: Icons.ListChecks, route: "/user/orders" },
    { name: "Watchlist", icon: Icons.Eye, route: "/user/watchlist" },
    { name: "Portfolio", icon: Icons.Briefcase, route: "/user/portfolio" },
    { name: "Fund", icon: Icons.Wallet, route: "/user/fund" },
  ];

  return (
    <>
      <style>
        {`
          .mobile-bottom-nav {
            display: none;
          }
          
          @media (max-width: 768px) {
            .mobile-bottom-nav {
              display: flex;
              position: fixed;
              bottom: 0;
              left: 0;
              right: 0;
              z-index: 1000;
              padding: 10px 0;
              justify-content: space-around;
              align-items: center;
              box-shadow: 0 -4px 10px rgba(0,0,0,0.1);
            }
            .bottom-nav-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              text-decoration: none;
              font-size: 0.75rem;
              gap: 4px;
              transition: transform 0.2s, color 0.3s;
            }
            .bottom-nav-item.active .bottom-nav-icon {
              transform: translateY(-2px);
            }
          }
        `}
      </style>
      <div className="mobile-bottom-nav bg-body border-top">
        {navItems.map((item, index) => {
          const isActive = location.pathname === item.route;
          return (
            <Link
              key={index}
              to={item.route}
              className={`bottom-nav-item ${isActive ? "text-success fw-bold active" : "text-secondary"}`}
            >
              <item.icon size={22} className="bottom-nav-icon" />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default BottomNav;
